import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSetFilterAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { BaseObjectFilters } from '../../store/bootstrap';
import * as fromTaskTypeActions from './task-type.actions';
import { TaskType } from './task-type.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: TaskType };
    filters: BaseObjectFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    filters: {
        searchTerm: '',
        sortBy: 'title',
        sortDirection: 1
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromTaskTypeActions.Actions): State {
    switch (action.type) {
        case fromTaskTypeActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromTaskTypeActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromTaskTypeActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromTaskTypeActions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.reducer.ts